/* Alabaster Readings — small behaviour layer for sections/main-reading.liquid and main-readings.liquid.
   Adds classes only; never changes text. */
(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  function text(el) { return (el.textContent || '').replace(/\s+/g, ' ').trim(); }

  // Scripture = a blockquote, a centred paragraph, or a paragraph that is wholly a quotation.
  function isScripture(el) {
    if (el.closest('.rd-quote')) return false;
    if (el.tagName === 'BLOCKQUOTE') return true;
    var t = text(el);
    if (t.length < 12 || t.length > 420) return false;
    var align = (el.getAttribute('style') || '') + ' ' + (el.getAttribute('align') || '');
    if (/center/i.test(align)) return true;
    return /^[“"]/.test(t) && /([”"]|[”"]\s*[—–-].{0,80}|\)\.?)$/.test(t);
  }

  function article(root) {
    var prose = root.querySelector('.rd-prose');
    if (!prose) return;

    // old Shogun "Additional readings" block at the end of posts; Continue Reading replaces it
    prose.querySelectorAll('h2, h3').forEach(function (h) {
      if (!/^(additional|related) readings?$/i.test(text(h))) return;
      var block = h.closest('.shg-fw') || h.closest('.shg-box');
      if (block && prose.contains(block)) block.style.display = 'none';
    });

    // standfirst: first paragraph that is entirely italic
    var first = Array.prototype.filter.call(prose.querySelectorAll('p'), function (p) { return text(p); })[0];
    if (first && first.children.length === 1 && /^(EM|I)$/.test(first.firstElementChild.tagName) && text(first) === text(first.firstElementChild)) {
      first.classList.add('rd-dek');
    }

    // scripture as a pull-quote
    prose.querySelectorAll('blockquote, p').forEach(function (el) {
      if (el.tagName !== 'BLOCKQUOTE' && el.closest('blockquote')) return;
      if (!isScripture(el)) return;
      var q = document.createElement('blockquote');
      q.className = 'rd-quote';
      var p = document.createElement('p');
      p.textContent = text(el);
      q.appendChild(p);
      el.replaceWith(q);
    });
  }

  function reveal(root) {
    if (reduce || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('rd-in'); io.unobserve(e.target); }
      });
    }, { threshold: 0.12 });
    root.querySelectorAll('.rd-prose .shogun-image-container, .rd-prose figure, .rd-story').forEach(function (el) {
      el.classList.add('rd-rv');
      io.observe(el);
    });
  }

  ready(function () {
    document.querySelectorAll('.rd-page').forEach(function (root) {
      if (root.classList.contains('rd-article')) article(root);
      reveal(root);
    });
  });
})();
